<div class="table-container">
  @if (data) {
    @if (data.data.length) {
      <p-table [value]="data.data" [scrollable]="true" class="p-datatable-striped">
        <ng-template pTemplate="header">
          <tr>
            <th>
              <button type="button" class="coupon-table__sort" (click)="sortChange.emit('code')">
                CÓDIGO <i [class]="sortIcon('code')"></i>
              </button>
            </th>
            <th>
              <button type="button" class="coupon-table__sort" (click)="sortChange.emit('description')">
                DESCRIÇÃO <i [class]="sortIcon('description')"></i>
              </button>
            </th>
            <th>DESCONTO</th>
            <th>
              <button type="button" class="coupon-table__sort" (click)="sortChange.emit('quantity')">
                QUANTIDADE <i [class]="sortIcon('quantity')"></i>
              </button>
            </th>
            <th>
              <button type="button" class="coupon-table__sort" (click)="sortChange.emit('expires_at')">
                EXPIRA EM <i [class]="sortIcon('expires_at')"></i>
              </button>
            </th>
            <th>
              <button type="button" class="coupon-table__sort" (click)="sortChange.emit('used_count')">
                UTILIZADOS <i [class]="sortIcon('used_count')"></i>
              </button>
            </th>
            <th>
              <button type="button" class="coupon-table__sort" (click)="sortChange.emit('status')">
                STATUS <i [class]="sortIcon('status')"></i>
              </button>
            </th>
            <th>AÇÕES</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-coupon>
          <tr>
            <td>{{ coupon.code }}</td>
            <td>{{ coupon.description ?? "-" }}</td>
            <td>{{ coupon.discount_percentage }}%</td>
            <td>{{ coupon.quantity }}</td>
            <td>{{ coupon.expires_at | date: "dd/MM/yyyy - HH'h'mm" }}</td>
            <td>{{ coupon.used_count }}</td>
            <td>
              <span class="coupon-table__status coupon-table__status--{{ coupon.status }}">
                {{ coupon.status_display }}
              </span>
            </td>
            <td>
              <div class="coupon-table__actions">
                @if (!readOnly) {
                  <button
                    mat-icon-button
                    aria-label="Editar cupom"
                    matTooltip="Editar"
                    [disabled]="!canEdit(coupon)"
                    (click)="editClick.emit(coupon)">
                    <mat-icon>edit</mat-icon>
                  </button>
                }
                <button
                  mat-icon-button
                  aria-label="Copiar link do cupom"
                  matTooltip="Copiar Link"
                  (click)="copyAffiliateLink(coupon)">
                  <mat-icon>link</mat-icon>
                </button>
                <button
                  mat-icon-button
                  aria-label="Visualizar cupom"
                  matTooltip="Visualizar"
                  (click)="viewDetailsClick.emit(coupon)">
                  <mat-icon>visibility</mat-icon>
                </button>
                @if (!readOnly) {
                  <button
                    mat-icon-button
                    aria-label="Desativar cupom"
                    matTooltip="Desativar"
                    [disabled]="!canDeactivate(coupon)"
                    (click)="deactivateClick.emit(coupon)">
                    <mat-icon>close</mat-icon>
                  </button>
                }
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>

      <p-paginator
        (onPageChange)="pageChange.emit($event)"
        [first]="first"
        [rows]="rows"
        [totalRecords]="data.meta.total_count || 0"
        [showCurrentPageReport]="false"
        [showPageLinks]="false"
        [showJumpToPageDropdown]="false"
        [rowsPerPageOptions]="[10, 20, 30]"
        currentPageReportTemplate="Mostrando {first} até {last} de {totalRecords}" />
    } @else {
      <div class="coupon-table__empty">
        <i class="pi pi-ticket"></i>
        @if (filtered) {
          <p>Nenhum cupom encontrado para os filtros aplicados.</p>
        } @else {
          <p>Você ainda não criou nenhum cupom.</p>
        }
      </div>
    }

    @if (loading) {
      <div class="coupon-table__loading" aria-live="polite" aria-busy="true">
        <p-progressSpinner [style]="{ width: '48px', height: '48px' }" strokeWidth="4" ariaLabel="Carregando" />
      </div>
    }
  } @else {
    <p-skeleton height="350px" />
  }
</div>
